/**
	MAIN.JS

    In this file, all used JavaScript modules come together ans one, as they are initialized right here.
 */
'use strict';

import InitHeadermenu from "./modules/navigation";
import InitAccordion from './modules/accordion';
import CookieByte from './modules/cookie-byte';
import InitNumberAnimation from './modules/number-animation';
import InitContactForm from './modules/contact-form';
import {InitTeamCards} from "./customer/cards";
import {InitSliders} from './customer/slider';
import {InitFilterSection} from "./customer/filter";
import Form from './form/form';
import Alpine from 'alpinejs';

const siteInitialization = () => {
	InitHeadermenu();
	InitAccordion();
	CookieByte.init();
	InitNumberAnimation();
	InitContactForm();
	InitTeamCards();
	InitSliders();
	InitFilterSection();
	Form.init();

	window.Alpine = Alpine;	
	Alpine.start();
};

// Run the init function as soon as the DOM tree has been loaded
if (document.readyState !== 'loading') siteInitialization();
else document.addEventListener('DOMContentLoaded', siteInitialization);
